import { ReactNode } from "react";
import classNames from "classnames";

type ErrorMessageProps = {
  children: ReactNode;
  className?: string;
};

const ErrorMessage = ({ children, className }: ErrorMessageProps) => {
  return (
    <div className={classNames("alert alert-danger", className)} role="alert">
      {children}
    </div>
  );
};

export default ErrorMessage;
